<template>
  <v-card elevation="0" class="terms-tabs transparent rounded-0">
    <ConditionOneTab></ConditionOneTab>
  </v-card>
</template>
<script>
import ConditionOneTab from './ConditionOneTab.vue';
export default {

  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    ConditionOneTab
  },
};
</script>
